import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import AdminLayout from "layouts/Admin/Admin.jsx";
import HomeLayout from "layouts/Admin/Home.jsx";
import WikiLayout from "layouts/Admin/Wiki.jsx";
import TosLayout from "layouts/Admin/Tos.jsx";
import PrivacyLayout from "layouts/Admin/Privacy.jsx";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { ToastContainer } from 'react-toastify';
import CookieConsent from "react-cookie-consent";
import Loader from './views/Loader';

import "assets/css/nucleo-icons.css";
import "react-notification-alert/dist/animate.css";
import "assets/scss/black-dashboard-pro-react.scss?v=1.2.0";
import "assets/demo/demo.css";

import { Provider } from 'react-redux';
import store from './redux/store/index';
import * as serviceWorker from './serviceWorker';
import {Helmet} from 'react-helmet';
import './i18n';

ReactDOM.render(
  <Suspense fallback={Loader}>
    <BrowserRouter>
      <img src="https://cdn-icons-png.flaticon.com/512/1801/1801901.png" onClick={() => window.open('https://discord.com/channels/856661122715484191/891431619964047480', '_blank')} className="callSupport"/>
      <Helmet>
        <title>RustLink ~ The best Rust+ Team Chat Discord Bot</title>
        <meta name="description" content="RustLink is a rust bot, with which you can control your smart switches, smart alarms, storage monitor. Track your storage, TCs upkeep, players. Monitor ingame events. Everything is customisable, and responsive."/>
        <meta name="keywords" content="Rust, Rust+, RustPlus, Rust Bot, RustLink, rust link, rust plus plus, rustplusplus, electricity"/>
      </Helmet>
      <ToastContainer theme="dark"/>
      <PayPalScriptProvider options={{ "client-id": "AW4TzZa-fG-R2Yc619abB0SLHkvVlklD7pUgBW14H9Mkgs0QJyp52DUK6Rp3EVBP_HzXXaOPRNyQU7a6", "vault": true, "intent": 'subscription' }}>
        <Switch>
          <Route path="/tos" render={(props) => <Provider store={store}><TosLayout {...props} /></Provider>} />
          <Route path="/privacy" render={(props) => <Provider store={store}><PrivacyLayout {...props} /></Provider>} />
          <Route path="/wiki" render={(props) => <Provider store={store}><WikiLayout {...props} /></Provider>} />
          <Route path="/home" render={(props) => <Provider store={store}><HomeLayout {...props} /></Provider>} />
          <Route path="/" render={(props) => <Provider store={store}><AdminLayout {...props} /></Provider>} />
        </Switch>
      </PayPalScriptProvider>
      <CookieConsent style={{ background: "#29293a" }} buttonStyle={{ background: "#2676f6", color: "white" }}>This website uses cookies to enhance the user experience.</CookieConsent>
    </BrowserRouter>
  </Suspense>,
  document.getElementById("root")
);

serviceWorker.unregister();
